'use client';
/** @jsxImportSource @emotion/react */

import { forwardRef, type Ref, type ElementType } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiTableSortLabel, {
  type TableSortLabelTypeMap as MuiTableSortLabelTypeMap,
} from '@mui/material/TableSortLabel';

import { CoreIcon } from '../core-icon/CoreIcon';

type ExcludedMuiProps = '';
type CustomProps = {
  component?: ElementType;
};

type TableSortLabelTypeMap<
  P = CustomProps,
  D extends ElementType = MuiTableSortLabelTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiTableSortLabelTypeMap['props'], ExcludedMuiProps> & P;
};

export type TableSortLabelProps<
  D extends ElementType = MuiTableSortLabelTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<TableSortLabelTypeMap<P, D>, D>;

function ArrowDown(props: Record<string, unknown>) {
  return <CoreIcon {...props} name="arrowdown" />;
}

const TableSortLabelComponent = (
  props: TableSortLabelProps,
  ref: Ref<HTMLSpanElement>
) => {
  return <MuiTableSortLabel IconComponent={ArrowDown} ref={ref} {...props} />;
};

TableSortLabelComponent.displayName = 'TableSortLabel';

export const TableSortLabel = forwardRef(
  TableSortLabelComponent
) as OverridableComponent<TableSortLabelTypeMap>;
